import { useEffect } from 'react';
import { setBusinessFavicon } from '../utils/faviconUtils';

const DynamicFavicon = () => {
  useEffect(() => {
    const updateFavicon = async () => {
      try {
        // Use the utility function to set business favicon
        const success = await setBusinessFavicon();
        
        if (success) {
          console.log('Dynamic favicon updated successfully');
        }
      } catch (error) {
        console.warn('Failed to load dynamic favicon:', error);
      }
    };

    // Update favicon when component mounts
    updateFavicon();
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default DynamicFavicon;
